import getPrinterlessInfoLink from '../../lib/getPrinterlessInfoLink';

export const RETURN_SUBMISSION_RECEIVED = 'RETURN_SUBMISSION_RECEIVED';
export const CLEAR_RETURN_SUBMISSION = 'CLEAR_RETURN_SUBMISSION';
export const RECEIVE_LABEL_URL = 'RECEIVE_LABEL_URL';
export const RECEIVE_PRINTERLESS_URL = 'RECEIVE_PRINTERLESS_URL';
export const RECEIVE_MULTI_LABEL = 'RECEIVE_MULTI_LABEL';
export const RECEIVE_ATTESTATION_VALUE = 'RECEIVE_ATTESTATION_VALUE';

export const clearReturnSubmission = () => ({
  type: CLEAR_RETURN_SUBMISSION,
});

export const receiveReturnSubmission = ({
  error_response: errors = null,
  return_process_info: returnProcessInfo = null,
}) => ({
  type: RETURN_SUBMISSION_RECEIVED,
  data: { errors, returnProcessInfo },
});

export const receivePrinterlessInfoLink = (encryptedReturnId) => (dispatch, getState) => {
  const { page: { locale } = {}, retailerSettings: { name: retailer } = {} } = getState();
  dispatch({
    type: RECEIVE_PRINTERLESS_URL,
    data: {
      printerlessUrl: getPrinterlessInfoLink({
        locale,
        retailer,
        encryptedReturnId,
      }),
    },
  });
};

export const receiveMultiLabel = (multiLabel) => ({
  type: RECEIVE_MULTI_LABEL,
  data: { multiLabel },
});

export const receiveAttestationValue = ({ field, value }) => ({
  type: RECEIVE_ATTESTATION_VALUE,
  data: { field, value },
});
